const localStorage = window.localStorage;
const storeName = 'FIFL:store';

export class LocalStore {
  constructor() {
    let storedObject = localStorage.getItem(storeName);

    if (!storedObject) {
      storedObject = JSON.stringify({});
      localStorage.setItem(storeName, storedObject);
    }
  }

  setValue(key, value) {
    let storedObject = localStorage.getItem(storeName);
    if (storedObject) {
      storedObject = JSON.parse(storedObject);
      storedObject[key] = value;
      localStorage.setItem(storeName, JSON.stringify(storedObject));
      return true;
    }
    return false;
  }

  getValue(key) {
    let storedObject = localStorage.getItem(storeName);

    storedObject = JSON.parse(storedObject);

    try {
      return storedObject[key];
    } catch (err) {
      return null;
    }
  }
}
